// 直接从源文件引入 Parent，避免经由 table_template 桶文件(index.ts)形成循环依赖：
// barrel → tableview_template → header_setting → modular_window → modular_parent → barrel。
// 该循环在 webpack4 下被容忍，rspack 下会因 barrel 尚未初始化 Parent 而读取 undefined.default 报错。
import Parent from "@src/components/table_template/parent";
import React, { Component } from "react";
class ModularParent extends (Parent || Component) {
    constructor(props) {
        super(props);
        if (props.getThis) {
            props.getThis(this);
        }
    }
}

export default ModularParent;
